import React from 'react';
import FormDrawer from "components/__new/common/form-drawer";
import { ReactComponent as IconInfo } from 'assets/images/icons/project-icons/information-new.svg';
import { ButtonLoader } from "components/__new/common/form";
import Maybe from "components/__new/common/Maybe";

export const OptOutYield = (props) => {
    const { isOpen, setIsOpen, employer, handleOptInOutYield, optInOutYieldLoading } = props;
    
    return (
        <FormDrawer display="center" size="2xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Opt-Out Of Yield"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <div className="mt-4 bg-[#FEF5E7] p-3 rounded-2xl flex items-center">
                    <IconInfo className="text-[#F49D1B] mr-3 w-12"/>
                    <span>
                        By opting out of yield, you will forfeit all accrued earnings from the start of the month until today. You will also cease to earn any yield until you opt back in. Please note that forfeited yield cannot be recovered.
                    </span>
                </div>

                <div className="mt-8">
                    <div className="flex items-center text-[#4A5564] font-normal">
                        Are you sure you want to perform this action?
                    </div>
                </div>

                <div className="p-1 mt-8 flex items-center space-x-3">
                    <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                    onClick={() => setIsOpen(false)}
                    >
                        Not Now
                    </button>
                    <ButtonLoader onClick={handleOptInOutYield} loading={optInOutYieldLoading} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Opt-Out
                    </ButtonLoader>
                </div>
            </div>
        </FormDrawer>
    )
}
